import PropTypes from 'prop-types';
import React from 'react';
import { ADDRESS_FIELDS } from '../../brands/default/content/components/address';
import FormikInput from '../_generic/input/FormikInput';

const AddressFields = ({
  isShowPostcode = false,
  onChangeFunction = () => {},
  onBlurFunction = () => {},
  values = {},
  errors = {},
  touched = {},
  componentClass = '',
  disabled = false,
}) => (
  <>
    <div className="col-12">
      <FormikInput
        dataqa="addressLine1"
        disabled={disabled}
        errorText={errors.addressLine1}
        extraClasses={componentClass}
        inputError={errors.addressLine1}
        inputTouched={touched.addressLine1}
        inputValue={values.addressLine1}
        name={'addressLine1'}
        onBlurFunction={onBlurFunction}
        onChangeFunction={onChangeFunction}
        placeholder={`${ADDRESS_FIELDS.registrationAddressOne}*`}
        type="text"
      />
    </div>
    <div className="col-12">
      <FormikInput
        dataqa="addressLine2"
        disabled={disabled}
        extraClasses={componentClass}
        inputValue={values.addressLine2}
        name={'addressLine2'}
        onBlurFunction={onBlurFunction}
        onChangeFunction={onChangeFunction}
        placeholder={ADDRESS_FIELDS.registrationAddressTwo}
        required={false}
        type="text"
      />
    </div>
    <div className="col-12">
      <FormikInput
        dataqa="city"
        disabled={disabled}
        errorText={errors.city}
        extraClasses={componentClass}
        inputError={errors.city}
        inputTouched={touched.city}
        inputValue={values.city}
        name={'city'}
        onBlurFunction={onBlurFunction}
        onChangeFunction={onChangeFunction}
        placeholder={`${ADDRESS_FIELDS.registrationCity}*`}
        type="text"
      />
    </div>
    {isShowPostcode && (
      <div className="col-12">
        <FormikInput
          dataqa="postCode"
          disabled={disabled}
          errorText={errors.postCode}
          extraClasses={componentClass}
          inputError={errors.postCode}
          inputTouched={touched.postCode}
          inputValue={values.postCode}
          name={'postCode'}
          onBlurFunction={onBlurFunction}
          onChangeFunction={onChangeFunction}
          placeholder={`${ADDRESS_FIELDS.registrationAddress}*`}
          type="text"
        />
      </div>
    )}
  </>
);

AddressFields.propTypes = {
  componentClass: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  isShowPostcode: PropTypes.bool,
  onBlurFunction: PropTypes.func,
  onChangeFunction: PropTypes.func,
  touched: PropTypes.object,
  values: PropTypes.object,
};

export default AddressFields;
